export var OPACITY_LEVELS={"0%":0,"25%":.25,"50%":.5,"75%":.75,"100%":1};